import { memo, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { paths } from '@/shared/config/paths';
import { useAuthStore } from '@/store/useAuthStore';
// 배럴(@/features/reception)로 받으면 같은 배럴이 re-export 하는 차트까지 끌려와
// recharts 가 초기 번들에 들어간다. 이 파일은 라우트에서 eager 로 불리므로 직접 경로로 받는다
import ReceptionExitModal from '@/features/reception/components/ReceptionExitModal';

// 리셉션 전용 레이아웃
const ReceptionLayout = () => {
	const expiresAt = useAuthStore(state => state.reception.expiresAt);
	const { logout, clearReception } = useAuthStore();
	const navigate = useNavigate();
	const [exitOpen, setExitOpen] = useState(false);

	// 8시간 TTL 만료 감지 (만료 시 상태 정리 후 홈으로)
	useEffect(() => {
		if (!expiresAt) return;
		const remaining = expiresAt - Date.now();
		if (remaining <= 0) {
			clearReception();
			navigate(paths.home.path, { replace: true });
			return;
		}
		const timer = window.setTimeout(() => {
			clearReception();
			navigate(paths.home.path, { replace: true });
		}, remaining);
		return () => window.clearTimeout(timer);
	}, [expiresAt, clearReception, navigate]);

	// 로그아웃
	const handleLogout = () => {
		logout();
		navigate(paths.login.path);
	};

	return (
		<Wrapper>
			<TopBar>
				<Logo>ROCK & RUN RECEPTION</Logo>
				<TopActions>
					<TopAction onClick={() => setExitOpen(true)}>스캔모드 나가기</TopAction>
					<TopAction $muted={true} onClick={handleLogout}>
						로그아웃
					</TopAction>
				</TopActions>
			</TopBar>
			<Content>
				<Outlet />
			</Content>
			<ReceptionExitModal open={exitOpen} onClose={() => setExitOpen(false)} />
		</Wrapper>
	);
};

export default memo(ReceptionLayout);

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background-color: ${({ theme }) => theme.colors.whiteColor};
`;
const TopBar = styled.header`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 80px;
	padding: 0 40px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrayBorder};
`;
const Logo = styled.div`
	font-size: 16px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
`;
const TopActions = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;
const TopAction = styled.div<{ $muted?: boolean }>`
	font-size: 14px;
	cursor: pointer;
	color: ${({ $muted, theme }) => ($muted ? theme.colors.lightGrayFontColor : theme.colors.blackColor)};
	transition: 0.2s;

	&:hover {
		color: ${({ theme }) => theme.colors.blackColor};
	}
`;
const Content = styled.main`
	flex: 1;
`;
